__turbopack_context__.v({
  "checkbox": "realTime-module-scss-module__noyLZq__checkbox",
  "wrapper": "realTime-module-scss-module__noyLZq__wrapper",
});
